'use strict';

angular.module('casist.utils', [
  'ui.bootstrap'
]);